import { createAsyncThunk } from '@reduxjs/toolkit';
import { getSearch } from '@/services/search';
import { changeSearch } from '@/store/slices/searchPageSlice';

export const getSearchAction = createAsyncThunk(
  'searchPage/getSearchAction',
  async (requestData: any, { dispatch }) => {
    const response = await getSearch(requestData);
    if (response?.data) {
      dispatch(changeSearch(response?.data));
      return { isSuccess: true };
    } else {
      return { isSuccess: false };
    }
  },
);
